/** SCRUM-343: an observation summary, never a claim of end-to-end service readiness. */
export type DeliveryHealthEvidence = Readonly<{
  complete: boolean;
  accepted: number;
  failed: number;
  unknown: number;
  credentialRejected: boolean;
  configuration: "present" | "missing" | "not-checked";
}>;

export type DeliveryHealthSignal =
  | "missing-configuration"
  | "credential-rejected"
  | "configuration-not-checked"
  | "incomplete"
  | "no-evidence"
  | "repeated-failures"
  | "failures-recorded"
  | "unknown-outcomes"
  | "no-failures-recorded";

export function deriveDeliveryHealth(evidence: DeliveryHealthEvidence): DeliveryHealthSignal {
  for (const count of [evidence.accepted, evidence.failed, evidence.unknown]) {
    if (!Number.isSafeInteger(count) || count < 0) {
      throw new Error("Delivery evidence counts must be non-negative safe integers.");
    }
  }
  if (evidence.configuration === "missing") return "missing-configuration";
  if (evidence.credentialRejected) return "credential-rejected";
  if (!evidence.complete) return "incomplete";
  if (evidence.failed >= 5 && evidence.failed / (evidence.accepted + evidence.failed) >= 0.2) {
    return "repeated-failures";
  }
  if (evidence.failed > 0) return "failures-recorded";
  if (evidence.unknown > 0) return "unknown-outcomes";
  if (evidence.configuration === "not-checked") return "configuration-not-checked";
  return evidence.accepted === 0 ? "no-evidence" : "no-failures-recorded";
}
